.header {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--tuna-palette-background-paper);
  border-bottom: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: var(--tuna-spacing-1, 8px) var(--tuna-spacing-2, 16px);
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;
  font-size: var(--tuna-typography-fontSize-sm);
  font-weight: 600;
  color: var(--tuna-palette-text-primary, rgba(0, 0, 0, 0.87));
  transition: background-color 120ms ease;
}

.toggle:hover,
.toggle:focus-visible {
  background-color: var(--tuna-palette-action-hover, rgba(0, 0, 0, 0.04));
}

.toggle:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.caret {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid currentColor;
  transition: transform 120ms ease;
}

.caret[data-expanded='true'] {
  transform: rotate(180deg);
}

.list {
  max-height: 320px;
  overflow-y: auto;
  border-top: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.06));
}
